<template>
  <el-card>
    <section>
      <!--工具条-->
      <el-col :span="24" class="form-line">
        <el-form size="small" :inline="true" :model="filters">
          <el-form-item label="昵称">
            <el-input v-model="filters.nickname" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="电话">
            <el-input v-model="filters.phone" auto-complete="off"></el-input>
          </el-form-item>
          <div style="float: right">
            <el-form-item>
              <el-button-group>
                <el-button type="primary" icon="el-icon-search" @click="getTUserList()">查询</el-button>
                <el-button icon="el-icon-refresh-right" @click="resetFilter()">重置</el-button>
              </el-button-group>
            </el-form-item>
          </div>
        </el-form>
      </el-col>

      <!--列表-->
      <el-table border size="medium" :data="tuserList" highlight-current-row v-loading="listLoading" @selection-change="selsChange">
        <el-table-column type="index" min-width="60">
        </el-table-column>
        <el-table-column prop="openid" label="openid" min-width="120">
        </el-table-column>
        <el-table-column prop="nickname" label="昵称" min-width="120">
        </el-table-column>
        <el-table-column prop="phone" label="电话" min-width="120">
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间" min-width="120">
        </el-table-column>
        <!--        <el-table-column prop="status" label="状态" min-width="120" :formatter="statusFormatter">-->
        <!--        </el-table-column>-->
      </el-table>

      <!--工具条-->
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          style="padding: 15px 5px">
      </el-pagination>

      <!--新增界面-->
      <el-dialog title="新增" :visible.sync="addFormVisible" :close-on-click-modal="false">
        <el-form size="small" :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
          <el-form-item label="登录名" prop="username">
            <el-input v-model="addForm.username" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="真实姓名" prop="name">
            <el-input v-model="addForm.name" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="车牌号" prop="carNo">
            <el-input v-model="addForm.carNo" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="电话" prop="phone">
            <el-input v-model="addForm.phone" auto-complete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click.native="addFormVisible = false">取消</el-button>
          <el-button size="small" type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>
    </section>
  </el-card>
</template>

<script>
/* eslint-disable */
import {doGet, doPost, download} from "@/api/api";

export default {
  name: 'DriverManagement',
  data () {
    return {
      filters: {
        nickname: '',
        phone: ''
      },
      tuserList: [],
      total: 0,
      listLoading: false,
      sels: [], // 列表选中列
      addFormVisible: false, // 新增界面是否显示
      addLoading: false,
      addFormRules: {
        username: [
          { required: true, message: '请输入登录名', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入真实姓名', trigger: 'blur' }
        ],
        carNo: [
          { required: true, message: '请输入车牌号', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入电话', trigger: 'blur' }
        ],
      },
      // 新增界面数据
      addForm: {
        username: '',
        name: '',
        phone: '',
        carNo: ''
      },
      messageTitle: '',
      messageSuc: '',
      value: '',
      user: {}
    }
  },
  methods: {
    handleSizeChange (val) {
      this.filters.pageSize = val
      this.getTUserList()
    },
    handleCurrentChange (val) {
      this.filters.pageNum = val
      this.getTUserList()
    },
    resetFilter () {
      Object.assign(this.$data.filters, this.$options.data().filters)
    },
    // 获取消息列表
    getTUserList () {
      this.loading = true
      doPost('/user/getPageList', this.filters).then((res) => {
        console.log(res.result)
        this.total = res.result.total
        this.tuserList = res.result.list
        this.loading = false
      })
    },
    downloadUser () {
      // axios下载数据
      download('/user/downloadUser', this.filters, '用户数据.xls')
    },
    resetPwd: function (id){
      this.$confirm('是否确认重置密码?', '提示', {
        type: 'warning'
      }).then(() => {
        this.loading = true
        var para = { id: id }
        doPost('/driver/resetPwd', para).then((res) => {
          this.loading = false
          this.$message({
            message: '重置成功',
            type: 'success'
          })
          this.getTUserList()
        })
      }).catch(() => {

      })
    },
    // 删除
    handleDel: function (id) {
      this.$confirm('是否确认删除?', '提示', {
        type: 'warning'
      }).then(() => {
        this.loading = true
        var para = { id: id }
        doPost('/driver/deleteById', para).then((res) => {
          this.loading = false
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getTUserList()
        })
      }).catch(() => {

      })
    },
    handleEdit: function (id){
      this.messageTitle = '修改'
      this.messageSuc = '修改成功'
      var para = {id: id}
      doPost('/driver/getById', para).then((res) => {
        this.addForm = res.result
        this.addFormVisible = true
      })
    },
    // 显示新增界面
    handleAdd: function () {
      this.addFormVisible = true
      this.addForm = {
        username: '',
        name: '',
        phone: '',
        carNo: ''
      },
          this.messageTitle = '新增'
      this.messageSuc = '新增成功'
    },
    addSubmit: function () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm('确认提交吗？', '提示', {}).then(() => {
            this.loading = true
            doPost('/driver/saveOrUpdate', this.addForm).then(res => {
              console.log(res)
              if (res.code === 200) {
                this.addFormVisible = false
                this.loading = false
                // 修改成功  提示信息
                this.$message({
                  message: this.messageSuc,
                  type: 'success'
                })
                this.getTUserList()
              }
            })
          })
        }
      })
    },
    selsChange: function (sels) {
      this.sels = sels
    },
    // 批量删除
    batchRemove: function () {
    },
    statusFormatter (row, column) {
      if (row.status === 1) {
        return '未读'
      } else if (row.status === 2) {
        return '已读'
      }
    }
  },
  mounted () {
    this.user = JSON.parse(sessionStorage.getItem('user'))
    this.getTUserList()
  }
}
</script>

<style scoped>
.driver-management {
  padding: 20px;
}
</style>
